import { FC } from 'react'
import { EMapType } from 'interface/map'
import SatelliteImage from 'assets/image/satellite.png'
import TerrainImage from 'assets/image/terrain.png'
import TrafficImage from 'assets/image/traffic.png'

type RouteLayersPopoverContentProps = {
  type: EMapType
  onChangeType: (type: EMapType) => void
}

export const MapTypePopoverContent: FC<RouteLayersPopoverContentProps> = ({
  type,
  onChangeType,
}) => {
  return (
    <div className="p-2 flex gap-5">
      <div
        className="flex flex-col items-center cursor-pointer"
        onClick={() => onChangeType(EMapType.SATELLITE)}
      >
        <div className={`rounded-[2px] h-[48px] w-[48px] ${type === EMapType.SATELLITE ? 'border border-[#006ADF] p-[2px]' : ''}`}>
          <img src={SatelliteImage} alt="Satellite" className="h-full w-full" />
        </div>
        <div className="text-xs text-text-default">Satellite</div>
      </div>
      <div
        className="flex flex-col items-center cursor-pointer"
        onClick={() => onChangeType(EMapType.TERRAIN)}
      >
        <div className={`rounded-[2px] h-[48px] w-[48px] ${type === EMapType.TERRAIN ? 'border border-[#006ADF] p-[2px]' : ''}`}>
          <img src={TerrainImage} alt="Terrain" className="h-full w-full" />
        </div>
        <div className="text-xs text-text-default">Terrain</div>
      </div>
      <div
        className="flex flex-col items-center cursor-pointer"
        onClick={() => onChangeType(EMapType.TRAFFIC)}
      >
        <div className={`rounded-[2px] h-[48px] w-[48px] ${type === EMapType.TRAFFIC ? 'border border-[#006ADF] p-[2px]' : ''}`}>
          <img src={TrafficImage} alt="Traffic" className="h-full w-full" />
        </div>
        <div className="text-xs text-text-default">Traffic</div>
      </div>
    </div>
  )
}
